export default "<div *ngFor=\"let s of sizes\" class=\"{{ s.css + ' ' + (prefix + s.id) }}\"></div>\r\n";